<template>
  <div class="youtaofang">
    <topTitle title="柏庭荟" :list="list" :newData="newData" :ContentStatus="ContentStatus" :remakTitle="remakTitle"></topTitle>
     <p class="top_p">
      钱湖柏庭声乐俱乐部有2个社团，分别是器乐社团、声乐社团。
    </p>
    <p class="top_p title" style="margin: 0">一、器乐社团</p>
    <p class="top_p" style="margin: 0">
      声乐，是用人声演唱的音乐形式；而器乐顾名思义，就是完全乐器演奏的音乐。
    </p>
    <p class="top_p" style="margin: 0">
      它沁人心脾，令人陶醉，就如生活中的一股清泉。
    </p>
     <p class="top_p" style="margin: 0">
      这股子清泉缓缓流淌，流淌进柏庭器乐社团每一位长者的心田里...
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/shenle.jpg" alt="" />
    </div>
     <p class="top_p title" style="margin: 0">二、声乐社团</p>
    <p class="top_p" style="margin: 0">
      优美、轻柔的歌声是一种良好的音质，也是一种美好的事物~
    </p>
     <p class="top_p" style="margin: 0">
      声乐社团的百灵鸟们，引吭高歌，引导着人们体会着喜、怒、哀、乐等各种情绪，“声”和“情”一旦相统一，便能体会到“声情并茂”的享受。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/shenle_1.jpg" alt="" />
    </div>
    <!-- <div class="item_bd" v-if="ContentStatus==false">
      <img :src="item.img" alt="" v-for="(item, key) in list2" :key="key" />
    </div>
     <div href="" class="navGet" @click="getHtml('3')" v-if="ContentStatus==false">“最美东钱湖”老年摄影大赛暨钱湖柏庭老年摄影俱乐部成立</div>
     <p v-html="dataContent" v-if="ContentStatus"></p> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
         {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
         {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
         {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
         {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        }
      ],
      newData:6,
      // list2: [
      //   {
      //     img: require("../assets/image/party/item_1.png"),
      //   },
      //   {
      //     img: require("../assets/image/party/item_2.png"),
      //   },
      //   {
      //     img: require("../assets/image/party/item_3.png"),
      //   },
      // ],
      dataContent:'',
      ContentStatus:false,
      remakTitle:'',
    };
  },
  methods: {
    getHtml(e){
       this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
  
    }
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p{
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet{
  display: inline-block;
font-size: 0.4rem;
font-family: PingFang SC;
font-weight: 500;
text-decoration: underline;
color: #3F674B;
line-height: 54px;
text-align: left;
margin-top: 0.6rem;
cursor: pointer;
}
.item_img{
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img img{
 width: 11.975rem;
/* height: 8.9875rem; */
}
.small_jiantou{
  display: inline-block;
  width: 0.1rem;
height: 0.1875rem;
background-image: url('../../assets/image/left_item1.png');
background-size: 100% 100%;
}
.item_jiantou1{
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2{
  background-image: url('../../assets/image/left_item2.png');
background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>